/**
 * Recetario MANGIBONE — realineado al diseño final (export .fig, 2026-09-28).
 *
 * Las 10 recetas y su copy (título, tiempo, tipo, porciones, producto,
 * ingredientes y pasos) se transcribieron del diseño Figma
 * (`Recetario-1.png` … `Recetario-10.png`, ver `docs/figma/recetas-diseno.json`).
 * Los botones de CTA del diseño son `Ir a comprar` y `Recetario`.
 *
 * TODO(diablo): exportar las 10 portadas de receta desde Figma y reemplazar
 * `imagen` (hoy comparte una portada temporal).
 */
export interface Recipe {
  slug: string;
  titulo: string;
  tiempo_preparacion: string;
  tipo_platillo: string | null;
  porciones: string;
  producto: string;
  imagen: string;
  descripcion?: string;
  ingredientes: string[];
  pasos: string[];
}

const coverTemporal = "/assets/figma/receta-componente/receta-longaniza-portada.png";

export const recipes: Recipe[] = [
  {
    slug: "queso-fundido-con-longaniza-y-rajas",
    titulo: "QUESO FUNDIDO CON LONGANIZA Y RAJAS",
    tiempo_preparacion: "30 minutos",
    tipo_platillo: "Entrada",
    porciones: "5 personas",
    producto: "Queso manchego",
    imagen: coverTemporal,
    descripcion:
      "Queso Manchego artesanal fundido a fuego lento con longaniza dorada al punto y rajas de chile serrano salteadas con cebolla.",
    ingredientes: [
      "400 g de queso Mangibone",
      "300 g de longaniza",
      "1/4 de cebolla",
      "Chile serrano al gusto",
      "Queso manchego",
    ],
    pasos: [
      "Pica la cebolla y sofríela en una sartén caliente.",
      "Agrega la longaniza y cocina hasta dorar completamente.",
      "Añade el queso desmenuzado y mezcla lentamente.",
      "Cocina hasta que el queso quede completamente fundido.",
    ],
  },
  {
    slug: "chilaquiles-divorciados-con-queso-oaxaca",
    titulo: "CHILAQUILES DIVORCIADOS CON QUESO OAXACA",
    tiempo_preparacion: "30 minutos",
    tipo_platillo: "Desayuno mexicano",
    porciones: "5 personas",
    producto: "Queso oaxaca",
    imagen: coverTemporal,
    descripcion:
      "Totopos crujientes divididos en salsa roja y verde tatemadas, pechuga deshebrada y abundante hebra fundente de Queso Oaxaca.",
    ingredientes: [
      "500 gr de totopos",
      "250 gr de salsa roja",
      "300 gr de salsa verde",
      "300 g de queso Oaxaca Mangibone",
      "1 pechuga de pollo deshebrada",
      "1/2 cebolla",
      "Cilantro",
      "Aceite",
      "Sal",
    ],
    pasos: [
      "Deja calentar el sartén con un poco de aceite.",
      "Calienta las salsas por separado en diferentes sartenes durante 5 minutos.",
      "Divide los totopos en dos partes y agrega salsa roja en un lado y salsa verde en el otro.",
      "Añade pollo deshebrado encima y coloca abundante queso Oaxaca desmenuzado.",
      "Decora con crema, cebolla y cilantro fresco antes de servir.",
    ],
  },
  {
    slug: "torta-de-milanesa",
    titulo: "TORTA DE MILANESA",
    tiempo_preparacion: "25 minutos",
    tipo_platillo: null,
    porciones: "5 personas",
    producto: "Queso manchego",
    imagen: coverTemporal,
    descripcion:
      "Crujiente bolillo tradicional con milanesa dorada, rebanadas de aguacate fresco y generoso Queso Manchego derretido al calor del comal.",
    ingredientes: [
      "5 bolillos",
      "5 milanesas de res o pollo",
      "250 g de queso manchego",
      "2 jitomates",
      "2 aguacates",
      "Mayonesa",
      "Aceite",
      "Queso manchego",
    ],
    pasos: [
      "Fríe las milanesas en aceite caliente hasta que estén doradas y bien cocidas.",
      "Parte los bolillos a la mitad y úntalos con mayonesa.",
      "Coloca una milanesa dentro de cada bolillo y agrega rebanadas de queso manchego.",
      "Calienta ligeramente para que el queso se derrita.",
      "Añade jitomate, lechuga y aguacate antes de servir.",
    ],
  },
  {
    slug: "enchiladas-suizas-con-queso-gouda",
    titulo: "ENCHILADAS SUIZAS CON QUESO GOUDA",
    tiempo_preparacion: "40 minutos",
    tipo_platillo: "comida mexicana",
    porciones: "5 personas",
    producto: "Queso Gouda",
    imagen: coverTemporal,
    descripcion:
      "Tortillas rellenas de pollo suave, bañadas en salsa verde cremosa y gratinadas al horno bajo una capa dorada de Queso Gouda Mangibone.",
    ingredientes: [
      "15 tortillas",
      "2 pechugas de pollo deshebradas",
      "300 g de queso Gouda Mangibone",
      "200 ml de crema",
      "1/2 cebolla",
      "Aceite",
      "Queso gouda",
    ],
    pasos: [
      "Fríe ligeramente las tortillas en aceite caliente.",
      "Rellena cada tortilla con pollo deshebrado y enróllalas.",
      "Colócalas en un refractario y cúbrelas con salsa verde.",
      "Agrega crema y queso Gouda rallado encima.",
      "Hornea durante 15 minutos hasta que el queso gratine.",
    ],
  },
  {
    slug: "panela-asada-con-verduras",
    titulo: "PANELA ASADA CON VERDURAS",
    tiempo_preparacion: "20 minutos",
    tipo_platillo: "platillo saludable",
    porciones: "5 personas",
    producto: "Queso panela",
    imagen: coverTemporal,
    descripcion:
      "Rebanadas firmes de Queso Panela asadas al sartén, acompañadas de calabazas, zanahorias y champiñones al aroma de aceite de oliva.",
    ingredientes: [
      "400 g de queso panela",
      "2 calabazas",
      "2 zanahorias",
      "200 g de champiñones",
      "Aceite de oliva",
      "Pimienta",
      "Sal",
    ],
    pasos: [
      "Corta las verduras en tiras medianas.",
      "Calienta una parrilla o sartén con un poco de aceite de oliva.",
      "Asa las verduras hasta que estén suaves y ligeramente doradas.",
      "Coloca el queso panela y cocina por ambos lados sin que se derrita completamente.",
      "Sirve caliente y sazona con sal y pimienta.",
    ],
  },
  {
    slug: "hamburguesa-gourmet-con-queso-gouda",
    titulo: "HAMBURGUESA GOURMET CON QUESO GOUDA",
    tiempo_preparacion: "30 minutos",
    tipo_platillo: "comida rápida",
    porciones: "5 personas",
    producto: "Queso gouda",
    imagen: coverTemporal,
    descripcion:
      "Carne selecta a la parrilla con tocino crujiente, vegetales frescos de temporada y una capa fundente de Queso Gouda de leche entera.",
    ingredientes: [
      "5 panes para hamburguesa",
      "5 carnes para hamburguesa",
      "250 g de queso Gouda Mangibone",
      "Tocino",
      "Lechuga",
      "Jitomate",
      "Catsup",
      "Queso gouda",
    ],
    pasos: [
      "Cocina las carnes en una parrilla o sartén caliente.",
      "Cuando estén listas, coloca el queso Gouda encima para que se derrita.",
      "Fríe el tocino hasta dejarlo crujiente.",
      "Calienta ligeramente los panes.",
      "Arma la hamburguesa agregando carne, tocino, verduras y aderezos.",
    ],
  },
  {
    slug: "pechuga-rellena-de-queso-manchego",
    titulo: "PECHUGA RELLENA DE QUESO MANCHEGO",
    tiempo_preparacion: "45 minutos",
    tipo_platillo: "plato fuerte",
    porciones: "5 personas",
    producto: "Queso manchego",
    imagen: coverTemporal,
    descripcion:
      "Pechuga empanizada doradita por fuera, rellena de jamón y corazón cremoso de Queso Manchego que desborda al primer bocado.",
    ingredientes: [
      "5 pechugas de pollo",
      "300 g de queso manchego",
      "5 rebanadas de jamón",
      "Pan molido",
      "2 huevos",
      "Aceite",
      "Sal y pimienta",
      "Queso manchego",
    ],
    pasos: [
      "Abre las pechugas cuidadosamente formando un bolsillo.",
      "Rellena con jamón y queso manchego.",
      "Pasa las pechugas por huevo y pan molido.",
      "Fríelas en aceite caliente hasta dorar por ambos lados.",
      "Sirve calientes acompañadas de ensalada o arroz.",
    ],
  },
  {
    slug: "sincronizadas-con-queso-oaxaca",
    titulo: "SINCRONIZADAS CON QUESO OAXACA",
    tiempo_preparacion: "15 minutos",
    tipo_platillo: null,
    porciones: "5 personas",
    producto: "Queso oaxaca",
    imagen: coverTemporal,
    descripcion:
      "Tortillas de harina doraditas al comal con abundante Queso Oaxaca Mangibone en hebra, jamón tierno y abanico de aguacate.",
    ingredientes: [
      "10 tortillas de harina",
      "300 g de queso Oaxaca Mangibone",
      "250 g de jamón",
      "2 aguacates",
      "Salsa al gusto",
    ],
    pasos: [
      "Coloca jamón y queso Oaxaca entre dos tortillas.",
      "Calienta en un comal o sartén.",
      "Cocina hasta que el queso se derrita y las tortillas estén doradas.",
      "Corta en triángulos.",
      "Sirve con aguacate y salsa.",
    ],
  },
  {
    slug: "pasta-cremosa-con-queso-port-salut",
    titulo: "PASTA CREMOSA CON QUESO PORT SALUT",
    tiempo_preparacion: "35 minutos",
    tipo_platillo: "pasta",
    porciones: "5 personas",
    producto: "Queso Port Salut",
    imagen: coverTemporal,
    descripcion:
      "Pasta al dente envuelta en una delicada salsa de mantequilla dorada, ajo confitado y suave Queso Port Salut Los Pinos.",
    ingredientes: [
      "500 g de pasta",
      "250 g de queso Port Salut Mangibone",
      "200 ml de crema",
      "2 dientes de ajo",
      "2 cucharadas de mantequilla",
      "Pimienta",
    ],
    pasos: [
      "Cuece la pasta en agua hirviendo con sal.",
      "En una sartén derrite la mantequilla y sofríe el ajo picado.",
      "Agrega la crema y mezcla lentamente.",
      "Añade el queso Port Salut hasta formar una salsa cremosa.",
      "Integra la pasta y sirve caliente con pimienta al gusto.",
    ],
  },
  {
    slug: "papas-gratinadas-con-queso-gouda-y-manchego",
    titulo: "PAPAS GRATINADAS CON QUESO GOUDA Y MANCHEGO",
    tiempo_preparacion: "40 minutos",
    tipo_platillo: null,
    porciones: "5 personas",
    producto: "Queso Gouda y Queso Manchego",
    imagen: coverTemporal,
    descripcion:
      "Capas finas de papa horneadas con crema fresca, nuez moscada y una costra dorada de doble queso: Gouda y Manchego.",
    ingredientes: [
      "6 papas grandes",
      "200 g de queso Gouda Mangibone",
      "200 g de queso manchego",
      "250 ml de crema",
      "2 cucharadas de mantequilla",
      "Sal y pimienta",
    ],
    pasos: [
      "Corta las papas en rodajas delgadas.",
      "Engrasa un refractario con mantequilla.",
      "Coloca capas de papa, crema y quesos rallados.",
      "Repite el proceso hasta llenar el molde.",
      "Hornea durante 30 minutos hasta gratinar y dorar la superficie.",
    ],
  },
];

export const recipeBySlug = (slug: string) => recipes.find((r) => r.slug === slug);

export default recipes;